/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseCourseidLanguagesId200,
  GetApiV1CourseCourseidLanguagesId401,
  GetApiV1CourseCourseidLanguagesId404,
  GetApiV1CourseCourseidLanguagesId500,
  GetApiV1CourseCourseidLanguagesIdPathParams,
  GetApiV1CourseCourseidLanguagesIdQueryResponse,
} from "../../types/courseLangsController/GetApiV1CourseCourseidLanguagesId.ts";
import { courseLangDetailViewModelSchema } from "../courseLangDetailViewModelSchema.ts";

export const getApiV1CourseCourseidLanguagesIdPathParamsSchema = z.object({
  courseId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1CourseCourseidLanguagesIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseCourseidLanguagesId200Schema = z.lazy(
  () => courseLangDetailViewModelSchema,
) as unknown as ToZod<GetApiV1CourseCourseidLanguagesId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseCourseidLanguagesId401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseCourseidLanguagesId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CourseCourseidLanguagesId404Schema =
  z.any() as unknown as ToZod<GetApiV1CourseCourseidLanguagesId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseCourseidLanguagesId500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseCourseidLanguagesId500>;

export const getApiV1CourseCourseidLanguagesIdQueryResponseSchema = z.lazy(
  () => getApiV1CourseCourseidLanguagesId200Schema,
) as unknown as ToZod<GetApiV1CourseCourseidLanguagesIdQueryResponse>;
